





























































import { Component, Prop, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import ExchangeRatesInjectorMixin from "@/mixins/exchangeRatesInjectorMixin";

// Types
import { IExchangeRate } from "@/models/exchangeRates";

@Component
export default class ExchangeRateListItem extends Mixins(
  ExchangeRatesInjectorMixin
) {
  // Props

  @Prop({ default: null })
  public exchangeRate!: IExchangeRate;

  @Prop({ default: false })
  public isLoading!: boolean;

  // Computed

  public get showSkeletons() {
    return _.isNull(this.exchangeRate);
  }

  public get baseCurrencyLabel() {
    const baseCurrency = _.find(this.$exchangeRatesData.currencies, [
      "id",
      this.exchangeRate?.base_currency_id
    ]);

    return `${_.get(baseCurrency, "name", "")}(${_.get(
      baseCurrency,
      "code",
      ""
    )})`;
  }

  public get exchangeCurrencyLabel() {
    const exchangeCurrency = _.find(this.$exchangeRatesData.currencies, [
      "id",
      this.exchangeRate?.currency_id
    ]);

    return `${_.get(exchangeCurrency, "name", "")}(${_.get(
      exchangeCurrency,
      "code",
      ""
    )})`;
  }
}
